import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./healthreports.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Input from "../../../shared/components/Input/Input";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Button from "../../../shared/components/Button/Button";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";

const initialState = {
  Name: "",
  Age: "",
  Phone: "",
  PastMedicalHistory: "",
  MedicationsUsedBefore: "",
  DiagnosticTesting: "",
  TreatmentAdvised: "",
  NameError: "",
  AgeError: "",
  PhoneError: "",
  PastMedicalHistoryError: "",
  MedicationsUsedBeforeError: "",
  DiagnosticTestingError: "",
  TreatmentAdvisedError: "",
};
class HealthReports extends React.Component {
  state = initialState;

  componentDidMount() {
    if (!localStorage.getItem("health_report_info")) {
      localStorage.setItem(
        "health_report_info",
        JSON.stringify({ existingHealthReports: [] })
      );
    }
  }

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let AgeError = "";
    let PhoneError = "";
    let PastMedicalHistoryError = "";
    let MedicationsUsedBeforeError = "";
    let DiagnosticTestingError = "";
    let TreatmentAdvisedError = "";

    if (!this.state.Name) {
      NameError = "Invalid Name";
    }

    if (!this.state.Age) {
      AgeError = "Enter Valid Age";
    }

    if (!this.state.Phone) {
      PhoneError = "Enter Valid Phone Number";
    }

    if (!this.state.PastMedicalHistory) {
      PastMedicalHistoryError = "This Feild Cannot Be Empty";
    }

    if (!this.state.MedicationsUsedBefore) {
      MedicationsUsedBeforeError = "This Feild Cannot Be Empty";
    }

    if (!this.state.DiagnosticTesting) {
      DiagnosticTestingError = "This Feild Cannot Be Empty";
    }

    if (!this.state.TreatmentAdvised) {
      TreatmentAdvisedError = "This Feild Cannot Be Empty";
    }

    if (
      NameError ||
      AgeError ||
      PhoneError ||
      PastMedicalHistoryError ||
      MedicationsUsedBeforeError ||
      DiagnosticTestingError ||
      TreatmentAdvisedError
    ) {
      this.setState({
        NameError,
        AgeError,
        PhoneError,
        PastMedicalHistoryError,
        MedicationsUsedBeforeError,
        DiagnosticTestingError,
        TreatmentAdvisedError,
      });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      let existingHealthReports = localStorage.getItem("health_report_info");
      existingHealthReports = JSON.parse(existingHealthReports);
      existingHealthReports.existingHealthReports.push(this.state);
      localStorage.setItem(
        "health_report_info",
        JSON.stringify(existingHealthReports)
      );

      toast.info("Updating Info....!", {
        autoClose: 2000,
      });
      this.setState(initialState);
    }
  };

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <Header name="Health Report" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <div className={basestyles.inputWidth}>
            <form>
              <label className={styles.hrName}>Name</label>
              <Input
                placeholder="Name"
                type="text"
                value={this.state.Name}
                name="Name"
                onChange={(e) => this.change(e)}
              />
              <div className={styles.error}>{this.state.NameError}</div>

              <label className={styles.hrAge}>Age</label>
              <Input
                type="text"
                min="15"
                max="100"
                step="1"
                placeholder="ex: 22"
                value={this.state.Age}
                name="Age"
                onChange={(e) => this.change(e)}
              />
              {this.state.AgeError ? (
                <div className={styles.error}>{this.state.AgeError}</div>
              ) : null}

              <label className={styles.hrphone}>Phone</label>
              <Input
                type="text"
                placeholder="1-555-777-6666"
                value={this.state.Phone}
                name="Phone"
                onChange={(e) => this.change(e)}
              />
              {this.state.PhoneError ? (
                <div className={styles.error}>{this.state.PhoneError}</div>
              ) : null}

              <label className={styles.hrprob}>Past Medical History</label>
              <Textarea
                placeholder="Accident, Flu, Injuries, Colds, Allergies, and  Headaches..etc"
                value={this.state.PastMedicalHistory}
                name="PastMedicalHistory"
                onChange={(e) => this.change(e)}
              />
              {this.state.PastMedicalHistoryError ? (
                <div className={styles.error}>
                  {this.state.PastMedicalHistoryError}
                </div>
              ) : null}

              <label className={styles.hrMedic}>Medications Used Before:</label>
              <Textarea
                type="text"
                placeholder="Tablets, Ointment, Syrups etc.."
                value={this.state.MedicationsUsedBefore}
                name="MedicationsUsedBefore"
                onChange={(e) => this.change(e)}
              />
              {this.state.MedicationsUsedBeforeError ? (
                <div className={styles.error}>
                  {this.state.MedicationsUsedBeforeError}
                </div>
              ) : null}

              <label className={styles.hrdiaonos}>Diagnostic Testing</label>
              <Textarea
                type="text"
                placeholder="Set out all reported symptoms and restrictions identified under the patient's present position. "
                value={this.state.DiagnosticTesting}
                name="DiagnosticTesting"
                onChange={(e) => this.change(e)}
              />
              {this.state.DiagnosticTestingError ? (
                <div className={styles.error}>
                  {this.state.DiagnosticTestingError}
                </div>
              ) : null}

              <label className={styles.hradvise}>Treatment Advised</label>
              <Textarea
                type="text"
                placeholder="Further Treatment or Rehabiliation the patient will require."
                value={this.state.TreatmentAdvised}
                name="TreatmentAdvised"
                onChange={(e) => this.change(e)}
              />
              {this.state.TreatmentAdvisedError ? (
                <div className={styles.error}>
                  {this.state.TreatmentAdvisedError}
                </div>
              ) : null}
              <div>
                <Button
                  onClick={(e) => this.onSubmit(e)}
                  buttonName="Submit"
                  style={{
                    color: "white",
                    margin: "20px 15px 30px",
                    padding: "10px 10px",
                    width: "90%",
                    maxWidth: "500px",
                  }}
                ></Button>
                <ToastContainer />
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default HealthReports;
